import React, { FC, useState } from 'react';
import { LegacyNote } from 'src/interfaces/api/Collaborative';
import EntityTable from 'src/components/Table';
import { TableColumn } from 'src/components/Table/EntityTable';
import notesState from 'src/recoil/atoms/notes';
import { Order } from 'src/interfaces/Table';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import EmployeeCell from '../EmployeeCell';
import { CollectionResponse } from 'src/interfaces/api/api';
import { IconButton } from '@material-ui/core';
import { MdDelete as DeleteIcon } from '@react-icons/all-files/md/MdDelete';

interface Props {
  hidden?: boolean;
  notesIds: LegacyNote['id'][];
  onRemoveNote: (noteId: LegacyNote['id']) => void;
  onGetNotes: (
    page: number,
    limit: number,
    orderBy: keyof LegacyNote,
    order: Order
  ) => Promise<CollectionResponse<LegacyNote>>;
}

const columns: TableColumn<LegacyNote>[] = [
  {
    id: 'title',
    type: 'text',
    label: 'Titre',
    link: (note: LegacyNote) => `/dashboard/note/${note.id}`,
  },
  {
    id: 'dateCreate',
    type: 'datetime',
    label: 'Crée le',
    sortable: true,
  },
  {
    id: 'creatorId',
    type: 'text',
    label: 'Créateur',
    renderValue: ({ creator }) => <EmployeeCell user={creator} />,
  },
];

const NoteTable: FC<Props> = ({ hidden, onGetNotes, onRemoveNote }) => {
  const [noteToRemove, setNoteToRemove] = useState<LegacyNote['id']>();

  const handleRemoveNote = async () => {
    if (noteToRemove) {
      await onRemoveNote(noteToRemove);
      setNoteToRemove(undefined);
    }
  };

  return (
    <>
      <EntityTable
        hidden={hidden}
        columns={columns}
        defaultOrderBy='dateCreate'
        atomState={notesState}
        actions={(note) => (
          <IconButton size='small' onClick={() => setNoteToRemove(note.id)}>
            <DeleteIcon />
          </IconButton>
        )}
        fetchEntitiesCallback={onGetNotes}
      />

      <ConfirmationDialog
        title='Attention'
        confirmationText='Supprimer'
        description='Vous allez supprimer cette note. Êtes-vous sûr ?'
        onClose={() => setNoteToRemove(undefined)}
        open={!!noteToRemove}
        onValidate={handleRemoveNote}
      />
    </>
  );
};

export default NoteTable;
